import { FC } from 'react'
import { useIsMdScreen, useIsSmScreen, useIsXsScreen } from '../../../../hooks'
import { Box, CircularProgress } from '../../../UI'
import { LoaderProps } from '../types'
import useStyles from './styles'

const OverlayLoader: FC<LoaderProps> = ({ children, loading = true }) => {
  const classes = useStyles()

  const [smScreen] = useIsSmScreen()
  const [xsScreen] = useIsXsScreen()
  const [mdScreen] = useIsMdScreen()
  const smallScreen = xsScreen || smScreen || mdScreen

  return (
    <>
      {loading && (
        <Box className={classes.root}>
          <CircularProgress disableShrink size={smallScreen ? 56 : 96} thickness={4} />
        </Box>
      )}
      {children}
    </>
  )
}

export default OverlayLoader
